/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    RetrievalPageDriversStep: {
        id: 'qnb.common.retrievalPage.driversStep',
        defaultMessage: 'Driver(s)'
    },
    RetrievalPageDetailsStep: {
        id: 'qnb.common.retrievalPage.detailsStep',
        defaultMessage: 'Details'
    },
    RetrievalPageQuoteStep: {
        id: 'qnb.common.retrievalPage.quoteStep',
        defaultMessage: 'Quote'
    },
    RetrievalPageMedicalStep: {
        id: 'qnb.common.retrievalPage.medicalStep',
        defaultMessage: 'Medical'
    },
    RetrievalPageAboutYouStep: {
        id: 'qnb.common.retrievalPage.RetrievalPageAboutYouStep',
        defaultMessage: 'About you'
    },
    RetrievalPageReviewStep: {
        id: 'qnb.common.retrievalPage.RetrievalPageReviewStep',
        defaultMessage: 'Review'
    },
    RetrievalPagePaymentStep: {
        id: 'qnb.common.retrievalPage.paymentStep',
        defaultMessage: 'Payment'
    },
    RetrievalPageConfirmationStep: {
        id: 'qnb.common.retrievalPage.confirmationStep',
        defaultMessage: 'Confirmation'
    },
    RetrievalPageQuoteTitle: {
        id: 'qnb.common.retrievalPage.quoteTitle',
        defaultMessage: 'Retrieve your {productName} insurance quote'
    },
    QQRetrievalPageQuoteTitle: {
        id: 'qnb.common.retrievalPage.QQRetrievalPageQuoteTitle',
        defaultMessage: 'Continue your {productName} insurance quote'
    },
    RetrievalPageQuoteDescription: {
        id: 'qnb.common.retrievalPage.quoteDescription',
        defaultMessage: 'To retrieve your quote please enter your reference number, surname, postcode and date of birth below then click the \'Retrieve my quote\' button.'
    },
    SmiRetrievalDescription: {
        id: 'qnb.common.retrievalPage.SmiRetrievalDescription',
        defaultMessage: 'So that we can retrieve the right quote, please enter your details below.'
    },
    RetrievalPageQuoteShortDescription: {
        id: 'qnb.common.retrievalPage.quoteShortDescription',
        defaultMessage: 'To retrieve your quote please enter your date of birth, postcode and {field} below then click the \'Retrieve my quote\' button.'
    },
    QQRetrievalPageQuoteDescription: {
        id: 'qnb.common.retrievalPage.QQRetrievalPageQuoteDescription',
        defaultMessage: 'To continue your quote please enter your surname, postcode and date of birth below then click the \'Continue my quote\' button.'
    },
    RetrievalPageReferenceNumber: {
        id: 'qnb.common.retrievalPage.referenceNumber',
        defaultMessage: 'Reference number'
    },
    RetrievalPageDateOfBirth: {
        id: 'qnb.common.retrievalPage.dateOfBirth',
        defaultMessage: 'Date of birth'
    },
    RetrievalButton: {
        id: 'qnb.common.retrievalPage.retrievalButton',
        defaultMessage: 'Retrieve my quote'
    },
    RetrievalPagePostCode: {
        id: 'qnb.common.retrievalPage.postCode',
        defaultMessage: 'Postcode'
    },
    RetrieveQuoteSurname: {
        id: 'qnb.common.retrievalPage.surname',
        defaultMessage: 'Surname'
    },
    RetrieveQuoteEmail: {
        id: 'qnb.common.retrievalPage.email',
        defaultMessage: 'Email'
    },
    RetrieveButton: {
        id: 'qnb.common.retrievalPage.RetrieveButton',
        defaultMessage: 'Retrieve my quote'
    },
    QQRetrieveButton: {
        id: 'qnb.common.retrievalPage.QQRetrieveButton',
        defaultMessage: 'Continue my quote'
    },
    RetrievalPageLockedError: {
        id: 'qnb.common.retrievalPage.lockedError',
        defaultMessage: 'You have reached the maximum number of attempts for entering your details. Please call us on {phoneNumber} for further assistance.'
    },
    RetrievalPageChangedOfflineError: {
        id: 'qnb.common.retrievalPage.changedOfflineError',
        defaultMessage: 'Sorry, we have been unable to retrieve your quote. If you have any questions or would like to discuss your policy, please call us on {phoneNumber}. '
    },
    RetrievalPageExpiredError: {
        id: 'qnb.common.retrievalPage.expiredError',
        defaultMessage: 'Unfortunately, the cover start date of this quote has passed so it cannot be retrieved. Please start a '
    },
    RetrievalPageInvalidCoverError: {
        id: 'qnb.common.retrievalPage.invalidCoverError',
        defaultMessage: 'Unfortunately, we have been unable to retrieve your quote. Please call us on {phoneNumber} or alternatively start a '
    },
    RetrievalPageWrongDetailsError: {
        id: 'qnb.common.retrievalPage.wrongDetailsError',
        defaultMessage: 'Sorry, we have been unable to retrieve your quote. Please check your details above, alternatively you can start a '
    },
    RetrievalPageNewQuote: {
        id: 'qnb.common.retrievalPage.newQuote',
        defaultMessage: 'New Quote'
    },
    RetrievalPageInfoBoxFirstParagraphMotor: {
        id: 'qnb.common.retrievalPage.infoBoxFirstParagraphMotor',
        defaultMessage: 'Saga’s car insurance has received the highest rating from independent financial information business Defaqto.'
    },
    RetrievalPageInfoBoxFirstParagraphHome: {
        id: 'qnb.common.retrievalPage.infoBoxFirstParagraphHome',
        defaultMessage: '5 Star Cover'
    },
    RetrievalPageInfoBoxSecondParagraphMotor: {
        id: 'qnb.common.retrievalPage.infoBoxSecondParagraphMotor',
        defaultMessage: 'Join over one million drivers currently covered by Saga!'
    },
    RetrievalPageInfoBoxSecondParagraphHome: {
        id: 'qnb.common.retrievalPage.infoBoxSecondParagraphHome',
        defaultMessage: 'Saga Home Insurance has received the highest rating, for the 6th consecutive year, from independent financial information business Defaqto.'
    },
    RetrievalPageMotor: {
        id: 'qnb.common.retrievalPage.motor',
        defaultMessage: 'motor'
    },
    RetrievalPageHome: {
        id: 'qnb.common.retrievalPage.home',
        defaultMessage: 'home'
    },
    RetrievalPageSmi: {
        id: 'qnb.common.retrievalPage.RetrievalPageSmi',
        defaultMessage: 'smi'
    },
    RetrievalPageTravel: {
        id: 'qnb.common.retrievalPage.RetrievalPageTravel',
        defaultMessage: 'spt'
    },
    RetrievalQuoteFirstTitleBestPrice: {
        id: 'qnb.common.retrievalPage.retrievalQuoteFirstTitleBestPrice',
        defaultMessage: 'Welcome to Saga...'
    },
    RetrievalQuoteSecondTitleBestPrice: {
        id: 'qnb.common.retrievalPage.retrievalQuoteSecondTitleBestPrice',
        defaultMessage: 'Thank you for using {aggregatorName} to obtain a Saga {productName} Insurance quote.'
    },
    RetrievalQuoteAdditionalDescriptionBestPrice: {
        id: 'qnb.common.retrievalPage.retrievalQuoteAdditionalDescriptionBestPrice',
        defaultMessage: '<b>Please note: </b><span>we ask you to re-enter these details as a security precaution to safeguard your information. You will not be required to re-enter all other previously supplied information.</span>'
    },
});
